import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { getApiMinOptionsApi } from '@/api/otherSources';
import { apiMinDownload, daysBetween, MAX_DAYS } from '@/store/function/common/apiMinDownload';
import { isDateAfterToday } from '@/utils/datetime';


import { DateTime } from 'luxon';
/**
 * 可下載的 API 來源。四家都開了（2026-09-03 逐家對過 `api_min` 的欄位分布才開的，
 * 哪些欄位天生是空的見 docs/agents/othersources.md）。
 *
 * `interpolated` 是各家的內插比例（抓取間隔不同，比例就差很多），
 * 講「約九成」比只講「有內插」更能讓人決定要不要勾「只要真實量測值」。
 */
var SOURCES = [{
  value: 'thingnario',
  text: 'Thingnario 慧景',
  interpolated: '約九成'
}, {
  value: 'solaredge',
  text: 'SolarEdge',
  interpolated: '約八成'
}, {
  value: 'smartpvms',
  text: 'SmartPVMS 華為',
  interpolated: '約八成'
}, {
  value: 'auo',
  text: 'AUO 友達',
  interpolated: '約八成'
}];
var today = function today() {
  return DateTime.local().setZone('Asia/Taipei').toFormat('yyyy-MM-dd');
};

/** 快捷對應的 [開始, 結束]，一律以今天為結束 */
var presetRange = function presetRange(p) {
  var end = DateTime.local().setZone('Asia/Taipei');
  return [end.minus({
    days: p.days - 1
  }).toFormat('yyyy-MM-dd'), end.toFormat('yyyy-MM-dd')];
};
export default {
  name: 'OtherSourcesDownload',
  data: function data() {
    return {
      provider: SOURCES[0].value,
      loadingOptions: false,
      downloading: false,
      plants: [],
      plantNo: '',
      devices: [],
      realOnly: false,
      dateRange: [today(), today()],
      maxDays: MAX_DAYS,
      datePresets: [{
        label: '今天',
        days: 1
      }, {
        label: '近 3 天',
        days: 3
      }, {
        label: '近 7 天',
        days: 7
      }]
    };
  },
  computed: {
    sourceOptions: function sourceOptions() {
      return SOURCES.map(function (s) {
        return {
          value: s.value,
          text: s.text
        };
      });
    },
    plant: function plant() {
      var _this = this;
      return this.plants.find(function (p) {
        return p.plantNo === _this.plantNo;
      });
    },
    plantOptions: function plantOptions() {
      if (!this.plants.length) return [{
        value: '',
        text: '尚無可下載的案場'
      }];
      return this.plants.map(function (p) {
        return {
          value: p.plantNo,
          text: "".concat(p.plantName, "\uFF08").concat(p.devices.length, " \u53F0\uFF09")
        };
      });
    },
    deviceOptions: function deviceOptions() {
      var _this$plant$devices,
        _this$plant,
        _this2 = this;
      // 編號前面那一長串是案場代碼，每台都一樣，畫面上只留尾巴才看得完
      return ((_this$plant$devices = (_this$plant = this.plant) === null || _this$plant === void 0 ? void 0 : _this$plant.devices) !== null && _this$plant$devices !== void 0 ? _this$plant$devices : []).map(function (d) {
        return {
          text: d.replace("".concat(_this2.plantNo, "-"), ''),
          value: d
        };
      });
    },
    lastDate: function lastDate() {
      var _this$plant$lastDate, _this$plant2;
      return (_this$plant$lastDate = (_this$plant2 = this.plant) === null || _this$plant2 === void 0 ? void 0 : _this$plant2.lastDate) !== null && _this$plant$lastDate !== void 0 ? _this$plant$lastDate : '';
    },
    interpolatedHint: function interpolatedHint() {
      var _SOURCES$find$interpo,
        _SOURCES$find,
        _this3 = this;
      return (_SOURCES$find$interpo = (_SOURCES$find = SOURCES.find(function (s) {
        return s.value === _this3.provider;
      })) === null || _SOURCES$find === void 0 ? void 0 : _SOURCES$find.interpolated) !== null && _SOURCES$find$interpo !== void 0 ? _SOURCES$find$interpo : '大部分';
    },
    /** 現在的區間剛好等於哪個快捷。算出來的，不另外存狀態 —— 手動改日期它自然就不亮了 */activePreset: function activePreset() {
      var _this$dateRange, _this$datePresets$fin, _this$datePresets$fin2;
      var _ref = (_this$dateRange = this.dateRange) !== null && _this$dateRange !== void 0 ? _this$dateRange : [],
        _ref2 = _slicedToArray(_ref, 2),
        from = _ref2[0],
        to = _ref2[1];
      return (_this$datePresets$fin = (_this$datePresets$fin2 = this.datePresets.find(function (p) {
        var _presetRange = presetRange(p),
          _presetRange2 = _slicedToArray(_presetRange, 2),
          pf = _presetRange2[0],
          pt = _presetRange2[1];
        return pf === from && pt === to;
      })) === null || _this$datePresets$fin2 === void 0 ? void 0 : _this$datePresets$fin2.label) !== null && _this$datePresets$fin !== void 0 ? _this$datePresets$fin : '';
    },
    days: function days() {
      var _this$dateRange2;
      var _ref3 = (_this$dateRange2 = this.dateRange) !== null && _this$dateRange2 !== void 0 ? _this$dateRange2 : [],
        _ref4 = _slicedToArray(_ref3, 2),
        from = _ref4[0],
        to = _ref4[1];
      return from && to ? daysBetween(from, to) : 0;
    },
    canDownload: function canDownload() {
      return Boolean(this.plantNo && this.devices.length && this.days >= 1 && this.days <= this.maxDays && !this.downloading);
    }
  },
  watch: {
    provider: function provider() {
      this.plantNo = '';
      this.loadOptions();
    },
    // 換案場就把勾選清掉 —— 裝置編號帶著案場代碼，換一場就完全對不上
    plantNo: function plantNo() {
      this.devices = [];
    }
  },
  methods: {
    isDateAfterToday: isDateAfterToday,
    presetRange: presetRange,
    setAll: function setAll(on) {
      this.devices = on ? this.deviceOptions.map(function (d) {
        return d.value;
      }) : [];
    },
    loadOptions: function loadOptions() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _res$data$plants, _res$data, _res$data2, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.loadingOptions = true;
                _context.prev = 1;
                _context.next = 4;
                return getApiMinOptionsApi(_this4.provider);
              case 4:
                res = _context.sent;
                _this4.plants = (_res$data$plants = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.plants) !== null && _res$data$plants !== void 0 ? _res$data$plants : [];
                if (res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.maxDays) _this4.maxDays = res.data.maxDays;
                if (_this4.plants.length) _this4.plantNo = _this4.plants[0].plantNo;
                _context.next = 14;
                break;
              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                console.log('load api_min options failed', _context.t0);
                _this4.plants = [];
              case 14:
                _this4.loadingOptions = false;
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }))();
    },
    download: function download() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this5$plant$plantNam, _this5$plant;
        var _this5$dateRange, from, to, range, _yield$apiMinDownload, ok, message;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this5.canDownload) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                // 資料量的上限在後端（伺服器記憶體），超過會回訊息。見 ADR-0007
                _this5.downloading = true;
                _this5$dateRange = _slicedToArray(_this5.dateRange, 2), from = _this5$dateRange[0], to = _this5$dateRange[1];
                range = from === to ? from : "".concat(from, "_").concat(to);
                _context2.next = 7;
                return apiMinDownload({
                  provider: _this5.provider,
                  plantNo: _this5.plantNo,
                  from: from,
                  to: to,
                  devices: _this5.devices,
                  realOnly: _this5.realOnly
                }, "".concat((_this5$plant$plantNam = (_this5$plant = _this5.plant) === null || _this5$plant === void 0 ? void 0 : _this5$plant.plantName) !== null && _this5$plant$plantNam !== void 0 ? _this5$plant$plantNam : _this5.plantNo, "_").concat(range));
              case 7:
                _yield$apiMinDownload = _context2.sent;
                ok = _yield$apiMinDownload.ok;
                message = _yield$apiMinDownload.message;
                if (!ok) _this5.$swal(message || '所選區間與裝置查無資料');
                _this5.downloading = false;
              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    this.loadOptions();
  }
};